if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          if (!this.classList.contains('atelier-lightbox')) return;
          if (event.target === this || event.target.matches('.product-media-modal__dialog, .product-media-modal__content')) {
            this.hide();
          }
        });
        this.querySelectorAll('[data-media-step]').forEach(button => {
          button.addEventListener('click', () => this.stepMedia(Number(button.dataset.mediaStep)));
        });
        this.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.stepMedia(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      stepMedia(step) {
        const media = [...this.querySelectorAll('[role="document"] > [data-media-id]')];
        if (media.length < 2) return;
        const index = Math.max(0, media.findIndex(item => item.classList.contains('active')));
        window.pauseAllMedia();
        this.showActiveMedia(media[(index + step + media.length) % media.length].dataset.mediaId);
      }

      showActiveMedia(id = this.openedBy.getAttribute('data-media-id')) {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${id}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${id}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');


        const container = this.querySelector('[role="document"]');
        container.scrollLeft = 0;
        container.scrollTop = 0;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
